import { connect } from 'react-redux';
import EventCard from '../../components/EventCard/EventCard';
import { parseEventDate } from '../../utils/eventDate';
import { getEventData } from '../../selectors/apiSelectors';
import { IAppState } from '../../types/state.d';

type EventCardContainerOwnProps = {
  className?: string;
};

export const mapStateToProps = (
  state: IAppState,
  ownProps: EventCardContainerOwnProps,
) => {
  const { name, startDate } = getEventData(state);
  return {
    name,
    date: startDate && parseEventDate(startDate),
    className: ownProps.className || '',
  };
};

export default connect(mapStateToProps)(EventCard);
